import { Pipe, PipeTransform } from '@angular/core';
import { activity_status, TaskStatus, TaskStatusId } from "../../core/models/task-status"

// TODO - access the global rxdb status data

@Pipe({name: 'taskStatusName'})
export class TaskStatusNamePipe implements PipeTransform {
  transform(statusId: number|TaskStatusId): string {
      return activity_status.Names[statusId] || TaskStatus.getStatusName(statusId as TaskStatusId)
  }
}

@Pipe({name: 'taskStatusCss'})
export class TaskStatusCssPipe implements PipeTransform {
    static getCssClassForId( statusId : number|TaskStatusId ) {
        let cssClass: string;
        //CTIA-881 switch statement explicit compare doesn't handle numbers in string form.
        if ( !statusId ) {
            cssClass = null;
        } else if ( statusId == 1 ) {
            cssClass = 'status-not-started';
        } else if ( statusId == 2 ) {
            cssClass = 'status-in-progress';
        } else if ( statusId == 3 ) {
            cssClass = 'status-complete';
        } else if ( statusId == 4 ) {
            cssClass = 'status-field-complete';
        } else if ( statusId == 5 ) {
            cssClass = 'status-review-complete';
        } else if ( statusId == 6) {
            cssClass = 'status-not-using';
        } else if ( statusId == 7) {
            cssClass = 'status-archived';
        } else if ( statusId === 'inProgress' ) {
            cssClass = 'status-in-progress';
        } else {
            cssClass = "status-" + statusId;
        }
        return cssClass;
    }

    transform(statusId: number|TaskStatusId): string {
        return TaskStatusCssPipe.getCssClassForId(statusId)
    }
}

@Pipe({name: 'isSuccessTaskStatus'})
export class IsSuccessTaskStatusPipe implements PipeTransform {
    transform(statusId: number): boolean {
        return statusId == 3;
    }
}

@Pipe({name: 'taskStatusBorderedCss'})
export class TaskStatusBorderedCssPipe implements PipeTransform {
    transform(statusId: number|TaskStatusId): string {
        const cssBaseName = TaskStatusCssPipe.getCssClassForId(statusId)
        return cssBaseName ? cssBaseName + '-border' : null
    }
}

